import { createResource, type RouteResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import { type DownloadFileData, fetchDownloadLinkEndpoint } from '../endpoints';

export const downloadAuditLogsResource: RouteResource<DownloadFileData> =
	createResource<DownloadFileData>({
		type: 'download-audit-logs-resource',
		getKey: () => 'download-audit-logs-resource',
		getData: async (routerContext) => {
			const uniqueKey = routerContext.match.params.exportUniqueKey;
			assert(
				!!uniqueKey,
				new AssertionError('downloadAuditLogs resource', 'uniqueKey must be defined'),
			);

			return fetchDownloadLinkEndpoint(uniqueKey);
		},
		maxAge: 0,
		isBrowserOnly: true,
	});
